import React, { useEffect, useState } from 'react'
import SectionType from 'models/types/ts/sectionType'
import LanguageType from 'models/language-type'
import { getRecruitmentCode, getRecruitmentRewards } from 'services/recruitment'
// import rewardsJson from 'lib/recruit/rewards.json'
import { RewardListModel } from 'models/recruit/RewardListModel'
import { Section } from 'layouts'
import { createRecruitmentCode } from 'services/recruitment/getRecruitmentCode'
import { useSelector } from 'react-redux'
import { getLoggedInJwt } from 'packages/authentication'
import { GlobalState } from 'types'
import { SocialShare, Rewards } from './components'
import loggedInStyle from './RecruitAuthenticated.module.scss'

interface Props {
    socialShareSection: SectionType
    language: LanguageType
}

const RecruitAuthenticated = (props: Props): JSX.Element => {
    const [inviteToken, setInviteToken] = useState<string>(null)
    const [rewards, setRewards] = useState<RewardListModel>(null)
    const userToken = useSelector((state: GlobalState) => getLoggedInJwt(state))

    useEffect(() => {
        const getRewards = async (): Promise<void> => {
            getRecruitmentRewards(userToken).then((res) => {
                setRewards(res)
            })
        }

        // Try to get the invite token, if not found, create one
        const getToken = async (): Promise<void> => {
            const token = await getRecruitmentCode(userToken)
            if (token) {
                setInviteToken(token)
                getRewards()
            } else {
                await createRecruitmentCode(userToken).then((success) => {
                    if (success) {
                        getRecruitmentCode(userToken).then((newToken) => {
                            setInviteToken(newToken)
                            getRewards()
                        })
                    }
                })
            }
        }

        getToken()
    }, [userToken])

    return (
        <div className={loggedInStyle.loggedIn}>
            <div className={loggedInStyle.inner}>
                <SocialShare
                    section={props.socialShareSection}
                    invitationToken={inviteToken}
                    isFetchingInvitation={!inviteToken}
                    language={props.language}
                />
            </div>
            <Section hasContent={!!rewards}>
                <Rewards rewards={rewards} hasContent />
            </Section>
        </div>
    )
}

export default RecruitAuthenticated
